import React, { createContext, useContext, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { passwordResetRequest } from '../api/apiendpoint';
import { authenticated_user, login, logout, register } from '../api/apiendpoint';
import { toast } from 'react-toastify';


const AuthContext = createContext();

export const AuthProvider = ({children}) => {

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const nav = useNavigate();
    
    const get_authenticated_user = async () => {
        try {
          const user = await authenticated_user();
          setUser(user);
        } catch (error) {
          setUser(null); // If the request fails, set the user to null
        } finally {
          setLoading(false); // Set loading to false after request completes
        }
    };

 const loginUser = async (username, password) => {
  try {
    const user = await login(username, password);
    if (user) {
      setUser(user);
      nav('/');
      return true;  // ✅ indicate login was successful
    } else {
      return false; // ❌ login failed
    }
  } catch (error) {
    console.error('Login error:', error);
    return false; // ❌ also return false on error
  }
};

const logoutUser = async () => {
  try {
    await logout();
    setUser(null);
    toast.success('You have been logged out.'); // ✅ toast here
    nav('/login');
  } catch (error) {
    console.error('Logout error:', error);
    toast.error('Failed to logout. Please try again.');
  }
};

const registerUser = async (userData, setErrors) => {
  const {
    username, first_name, phone_number, last_name, city,
    address, email, password, confirm_password
  } = userData;

  if (password !== confirm_password) {
    setErrors({ confirm_password: "Passwords do not match" });
    return false;  // indicate failure
  }

  try {
    await register(username, first_name, phone_number, last_name, city, address, email, password);
    return true;  // success
  } catch (error) {
    if (error.response && error.response.data) {
      setErrors(error.response.data);  // from backend
    } else {
      setErrors({ general: "Something went wrong. Please try again." });
    }
    return false; // failure
  }
};





    useEffect(() => {
        get_authenticated_user();
    }, [window.location.pathname])

    const forgotPassword = async (email) => {
  try {
    const result = await passwordResetRequest(email);
    return { success: true, message: "If this email exists, a reset link has been sent." };
  } catch (error) {
    return { success: false, message: error.error || "Failed to send reset email." };
  }
};

    return (
        <AuthContext.Provider value={{ user, loading, loginUser, logoutUser, registerUser, forgotPassword }}>
          {children}
        </AuthContext.Provider>
      );
}



export const useAuth = () => useContext(AuthContext);